export const PRESET_TONE_OF_VOICE = {
  engaging: 'engaging',
  innovator: 'innovator',
  trendsetter: 'trendsetter',
  advisor: 'advisor',
  motivator: 'motivator',
  entertainer: 'entertainer',
  empathetic: 'empathetic',
  rebel: 'rebel',
};

export const MANUAL_TONE_OF_VOICE = {
  friendly: 'friendly',
  confident: 'confident',
  witty: 'witty',
  urgent: 'urgent',
  creative: 'creative',
  informative: 'informative',
};

export const MANUAL_TONE_OF_VOICE_PROPS = {
  [MANUAL_TONE_OF_VOICE.friendly]: {
    title: 'Friendly',
  },
  [MANUAL_TONE_OF_VOICE.confident]: {
    title: 'Confident',
  },
  [MANUAL_TONE_OF_VOICE.witty]: {
    title: 'Witty',
  },
  [MANUAL_TONE_OF_VOICE.urgent]: {
    title: 'Urgent',
  },
  [MANUAL_TONE_OF_VOICE.creative]: {
    title: 'Creative',
  },

  [MANUAL_TONE_OF_VOICE.informative]: {
    title: 'Informative',
  },
};

export const PRESET_TONE_OF_VOICE_PROPS = {
  [PRESET_TONE_OF_VOICE.engaging]: {
    id: PRESET_TONE_OF_VOICE.engaging,
    title: 'Neutral',
    description: 'The standard AI tone of voice.',
    label: '',
  },
  [PRESET_TONE_OF_VOICE.innovator]: {
    id: PRESET_TONE_OF_VOICE.innovator,
    title: 'Innovator',
    description: 'Share new developments and ideas.',
    label: 'Apple, Tesla, Google',
  },
  [PRESET_TONE_OF_VOICE.trendsetter]: {
    id: PRESET_TONE_OF_VOICE.trendsetter,
    title: 'Trendsetter',
    description: 'Connect with social media natives.',
    label: 'Netflix, TikTok, Spotify',
  },
  [PRESET_TONE_OF_VOICE.advisor]: {
    id: PRESET_TONE_OF_VOICE.advisor,
    title: 'Advisor',
    description: 'Establish credibility with expert advice.',
    label: 'J.P. Morgan, TED, McKinsey & Co',
  },
  [PRESET_TONE_OF_VOICE.motivator]: {
    id: PRESET_TONE_OF_VOICE.motivator,
    title: 'Motivator',
    description: 'Inspire readers, driving them toward action.',
    label: 'Nike, Under Armour, Peloton',
  },
  [PRESET_TONE_OF_VOICE.entertainer]: {
    id: PRESET_TONE_OF_VOICE.entertainer,
    title: 'Entertainer',
    description: 'Create fun copy that makes people smile.',
    label: 'Snickers, Old Spice, Duolingo',
  },
  [PRESET_TONE_OF_VOICE.empathetic]: {
    id: PRESET_TONE_OF_VOICE.empathetic,
    title: 'Empathetic',
    description: 'Show care and connect on a deeper level.',
    label: 'Dove, Airbnb, Cadbury',
  },
  [PRESET_TONE_OF_VOICE.rebel]: {
    id: PRESET_TONE_OF_VOICE.rebel,
    title: 'Rebel',
    description: 'Challenge conventions and push boundaries.',
    label: 'Harley Davidson, Diesel, Virgin',
  },
};

export const DEFAULT_SUGGEST_TOV_MODE = PRESET_TONE_OF_VOICE.engaging;

export const TONE_OF_VOICE_TYPE = {
  presets: 'presets',
  manual: 'manual',
};

export const EMPTY_MANUAL_TONE_OF_VOICE = [];
